import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { ToolbarModule } from 'primeng/toolbar';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { UserModel } from '@tsin-core/models/auth.model';
import { AuthState } from '@tsin-core/states/auth.state';
import { Observable, take } from 'rxjs';
import { Store } from '@ngxs/store';
import { LogoutAction } from '@tsin-core/actions/auth.action';
import { environment } from '@tsin-env/environment';
import { Router } from '@angular/router';
import { signOut } from 'aws-amplify/auth';
import { ConfigService } from '@tsin-core/services/common/config.service';

@Component({
    selector: 'app-main-header',
    standalone: true,
    imports: [CommonModule, AvatarModule, ButtonModule, ToolbarModule, CardModule],
    templateUrl: './main-header.component.html',
    styleUrl: './main-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainHeaderComponent {
    store: Store = inject(Store);
    router: Router = inject(Router);
    private configService: ConfigService = inject(ConfigService);
    authState$: Observable<UserModel | null> = this.store.select<UserModel | null>(
        AuthState.getCurrentUser
    );
    loading$: Observable<boolean> = this.store.select(AuthState.isLoading);

    goToMainPage() {
        this.authState$.subscribe((auth) => {
            if (auth?.isStaff) {
                this.router.navigate(['management/select-programs']);
                return;
            }
        });
    }
    goToProfile() {
        this.router.navigate(['employee/profile']);
    }
    logout() {
        // Clear NGXS state
        this.store.dispatch(new LogoutAction());

        // In staging/production, sign out via Cognito (Amplify)
        const env = this.configService.getEnvironment();
        if (env !== 'dev') {
            console.log('🔐 Signing out from Cognito...');
            signOut()
                .then(() => {
                    console.log('✅ Signed out from Cognito');
                    // Cognito will redirect to redirectSignOut URL (publicGuard-protected route)
                })
                .catch((error) => {
                    console.error('❌ Cognito sign out error:', error);
                    // Fallback: navigate to the publicGuard-protected login route
                    this.router.navigate(['/account/validate-login']);
                });
        } else {
            // Dev mode: redirect to the external user management login
            window.location.href = environment.userMgtUrl;
        }
    }
}
